import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import _ from 'lodash';
import { InputSearchIcon } from '../../common/input/input';
import './check-box-list.scss';
var CheckBoxList = function (props) {
    var data = props.data, onChangeCheckbox = props.onChangeCheckbox, isCheckAll = props.isCheckAll, disabled = props.disabled, placeholderKeyWord = props.placeholderKeyWord, footer = props.footer;
    var t = useTranslation().t;
    var _a = useState(false), checked = _a[0], setCheckAll = _a[1];
    var _b = useState([]), dataCheckBox = _b[0], setDataCheckbox = _b[1];
    var _c = useState(""), searchingText = _c[0], setSearchingText = _c[1];
    useEffect(function () {
        setCheckAll(isCheckAll);
    }, [isCheckAll]);
    useEffect(function () {
        if (data) {
            var dataSum = _.cloneDeep(data);
            var dataList = _.sortBy((dataSum || []), function (option) { return option.name; });
            // setCheckAll(isCheckAll);
            var dataFilter = dataList.filter(function (item) {
                if (!searchingText)
                    return true;
                var name = item.name.toLowerCase();
                return name.indexOf(searchingText.toLowerCase()) > -1;
            });
            setDataCheckbox(dataFilter);
        }
    }, [data]);
    var onSearchTextChange = function (event) {
        if (event && event.target) {
            var searchText_1 = event.target.value;
            var dataOriginal = data && data.length ? _.cloneDeep(data) : [];
            var dataChecked_1 = (dataCheckBox || []).filter(function (item) { return item.isCheck; });
            var dataFilter = dataOriginal.filter(function (item) {
                if (!searchText_1)
                    return true;
                var name = item.name.toLowerCase();
                return name.indexOf(searchText_1.toLowerCase()) > -1;
            });
            var isCheckAll_1 = true;
            dataFilter = dataFilter.map(function (item) {
                var foundItemChecked = (dataChecked_1 || []).find(function (itemChecked) { return itemChecked.id === item.id; });
                if (foundItemChecked) {
                    item.isCheck = true;
                }
                else {
                    isCheckAll_1 = false;
                }
                return item;
            });
            if (!dataFilter || !dataFilter.length)
                isCheckAll_1 = false;
            dataFilter = _.sortBy((dataFilter || []), function (option) { return option.name; });
            setCheckAll(isCheckAll_1);
            setSearchingText(searchText_1);
            setDataCheckbox(dataFilter);
        }
    };
    var onChangeAllCheckbox = function (event) {
        var dataOriginal = data && data.length ? _.cloneDeep(data) : [];
        var dataCheck = dataCheckBox.map(function (item, indexItem) {
            item.isCheck = event.target.checked;
            return item;
        });
        var dataOriginCheck = dataOriginal.map(function (item) {
            var foundItemChecked = (dataCheck || []).find(function (itemChecked) { return itemChecked.id === item.id; });
            if (foundItemChecked) {
                item.isCheck = foundItemChecked.isCheck;
            }
            return item;
        });
        setCheckAll(event.target.checked);
        setDataCheckbox(dataCheck);
        onChangeCheckbox(dataOriginCheck, event.target.checked);
    };
    var onChangeCheck = function (index, event) {
        var checkAll = true;
        var dataOriginal = data && data.length ? _.cloneDeep(data) : [];
        var dataCheck = dataCheckBox.map(function (item, indexItem) {
            if (index == indexItem)
                item.isCheck = event.target.checked;
            if (!item.isCheck) {
                checkAll = false;
            }
            return item;
        });
        var dataFilter = dataOriginal.filter(function (item) {
            if (!searchingText)
                return true;
            var name = item.name.toLowerCase();
            return name.indexOf(searchingText.toLowerCase()) > -1;
        });
        dataFilter = dataFilter.map(function (item) {
            var foundItemChecked = (dataCheck || []).find(function (itemChecked) { return itemChecked.id === item.id; });
            if (foundItemChecked) {
                item.isCheck = foundItemChecked.isCheck;
            }
            return item;
        });
        var dataOriginCheck = dataOriginal.map(function (item) {
            var foundItemChecked = (dataCheck || []).find(function (itemChecked) { return itemChecked.id === item.id; });
            if (foundItemChecked) {
                item.isCheck = foundItemChecked.isCheck;
            }
            return item;
        });
        dataFilter = _.sortBy((dataFilter || []), function (option) { return option.name; });
        setCheckAll(checkAll);
        setDataCheckbox(dataFilter);
        onChangeCheckbox(dataOriginCheck, checkAll);
    };
    return (React.createElement("div", { className: "content-bordered " + (disabled ? "disabled" : "") },
        React.createElement("div", { className: "cb-row cb-row-header" },
            React.createElement("label", { className: "item item-full", key: "item-all" },
                React.createElement("input", { type: "checkbox", disabled: disabled, onChange: onChangeAllCheckbox, checked: checked }),
                " ",
                React.createElement("i", { className: "title" }, t('common.all'))),
            React.createElement("div", { className: "search-checkbox" },
                React.createElement(InputSearchIcon, { type: "text", onChange: onSearchTextChange, iconName: "search", value: searchingText, placeholder: placeholderKeyWord ? placeholderKeyWord : t("common.keyword"), className: "filterable-search-input" }))),
        dataCheckBox && dataCheckBox.length ? React.createElement("div", { className: "cb-row cb-overflow" }, (dataCheckBox || []).map(function (item, index) {
            return React.createElement("label", { className: "item", title: item.name, key: index },
                React.createElement("input", { type: "checkbox", disabled: disabled, onChange: function (event) { return onChangeCheck(index, event); }, checked: item.isCheck }),
                " ",
                React.createElement("span", { className: "title" }, item.name));
        })) : null,
        footer ? React.createElement("div", { className: "cb-row" }, footer) : null));
};
export default CheckBoxList;
